import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('approvals');
    }

    dict (params) {
        return this.client.request ({
            method: 'get',
            path: '/publisher/v1/dict/approvals-offers',
            params: params,
        });
    }

    download (data) {
        const { sort, limit, offset, ...params } = { ...data };

        return this.client.download ({
            method: 'get',
            path: '/publisher/v1/approvals/download',
            params,
        });
    }

    bannersList (id) {
        return this.client.request ({
            method: 'get',
            path: `/publisher/v1/approvals/${id}/banners`,
        });
    }

    payouts (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/publisher/v1/approvals/${id}/payouts`,
            params,
        });
    }

    clicktagsList (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/publisher/v1/approvals/${id}/clicktag`,
            params,
        });
    }
}

export default new Resource;
